import { useEffect } from "react";

const useTitle = title => {
    useEffect(() => {
        document.title = `${title} - Food Zone`
    },
        [title])
};
export default useTitle;